import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/core/services/app.service';
import { EventEmitterService } from 'src/app/core/services/event-emitter.service';

import { GlobalVariableService } from 'src/app/core/services/global-variable.service';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-solde-arbitrage',
  templateUrl: './solde-arbitrage.component.html',
  styleUrls: ['./solde-arbitrage.component.css']
})

export class SoldeArbitrageComponent implements OnInit {
  clickEventSubscription: Subscription;
  @Input() solde;
  detailsSoldeAM: any;
  detailsSoldeIC: any;
  detailsSoldeOE: any;
  detailsSolde: any;
  user: any;
  constructor(
    private _service: AppService, 
    private _toastr: ToastrService,
    private variable: GlobalVariableService, 
    private sharedService: SharedDataService, 
    private storage: LocalStorageService) {
    this.clickEventSubscription = this.sharedService.getClickEventRefreshTableSoldesArbitrage().subscribe(() => {
      this.getSoldeArbitrage();
    });
  }

  ngOnInit() {
    this.user = JSON.parse(this.variable.getUser());
    this.getSoldeArbitrage();
  }

  // Get all my Arbitrage
  getSoldeArbitrage() {
    this.detailsSoldeAM = this.solde?.AM;
    this.detailsSoldeIC = this.solde?.IC;
    this.detailsSoldeOE = this.solde?.OE;
    this.detailsSolde = this.solde;
  }

}
